import { CurriedFunction1, CurriedFunction2, CurriedFunction3, CurriedFunction4 } from 'lodash4';
import { RegularExpression } from '../core/regular_expression';
import * as _4 from 'lodash4';

export class NumberUtility {
  static formatNumber = _4.curry((formatFunction: Function, numberToFormat: number | string): number | string => {
    return formatFunction(parseFloat(numberToFormat as string));
  });

  static stripTrailingZeroes = NumberUtility.formatNumber((number: number): string => {
    return number === 0 ? String(0) : String(number).replace(/\.+$/, '');
  });
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/types/number.ts